import React, { useState, useEffect } from 'react';
import './style.css';
import Header from '../User/Header';
import Footer from '../User/Footer';
import { useParams } from 'react-router-dom';
import bgImage from "../../assets/images/Manthinking-bro.png";
import {startAssessment,getNextQuestion} from '../../services/userassessment';
import loading from "../../assets/images/loader_grey.gif";
import SweetAlert from "react-bootstrap-sweetalert";

function Quiz() {
    const params = useParams();
    const seoName = params.seoName;
    const [assessmentId, setAssessmentId] = useState();
    const [itemId, setItemId] = useState();
    const [question, setQuestion] = useState();
    const [l1, setL1] = useState(0);
    const [l2, setL2] = useState(0);
    const [value, setValue] = useState();
    const [trueOp, setTrueOp] = useState("True");
    const [falseOp, setFalseOp] = useState("False");
    const [questionNo, setQuestionNo] = useState();
    const [yesBgClr, setYesBgClr] = useState();
    const [noBgClr, setNoBgClr] = useState("rgb(204 204 204)");
    const [animation, setAnimation] = useState("false");
    const [alertMsg, setAlertMsg] = useState(false);
    // The most questions this assessment can ask. The test stops early once it is confident, so
    // progress is shown against this ceiling rather than as a fixed count.
    const [maxQuestions, setMaxQuestions] = useState();
    // Guards against a second answer (a double click) being sent before the first returns.
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (sessionStorage.getItem('assessmentId')!=null) {
        setAssessmentId(sessionStorage.getItem('assessmentId'));
        startQuiz();
        }else{
          window.location.href = '/assessments';
        }
    }, []);
    const startQuiz = async () => {
        setAlertMsg(true);
        try {
            const response = await startAssessment(sessionStorage.getItem('assessmentId'));
            setAlertMsg(false);
            if (response.data.data != null) {
                // The server owns the attempt: a resumed attempt comes back on the question it
                // stopped at, with that question's number.
                setItemId(response.data.data.itemId);
                setQuestion(response.data.data.question);
                setQuestionNo(response.data.data.questionNo || 1);
                setMaxQuestions(response.data.data.maxQuestions);
            }
        } catch (error) {
            setAlertMsg(false);
            console.error(error);
            window.location.href = '/assessments';
        }
    };

    const onChangeValue = (val) => {
        if (submitting) {
            return;
        }
        setSubmitting(true);
        setValue(val);
        if (val === "yes") {
            setYesBgClr("green");
            setNoBgClr("rgb(204 204 204)");
        } else {
            setNoBgClr("green");
            setYesBgClr("rgb(204 204 204)");
        }
        window.setTimeout(function () {
            nextQuestion(val);
        }, 1000);
    }

    const nextQuestion = async (val) => {
        if (val != null) {
            let response;
            try {
                // questionNo, l1 and l2 are still sent for an older server during a deploy; the
                // current server ignores them and scores from the attempt it holds.
                response = await getNextQuestion(itemId, val, questionNo,l1,l2);
            } catch (error) {
                setSubmitting(false);
                setValue(null);
                setYesBgClr("rgb(204 204 204)");
                setNoBgClr("rgb(204 204 204)");
                if (error.response && error.response.status === 409) {
                    // The server was waiting on a different question (a second tab, a repeated
                    // click). Ask it where the attempt is and carry on from there.
                    startQuiz();
                    return;
                }
                console.error(error);
                window.location.href = '/assessments';
                return;
            }
            setSubmitting(false);
            setYesBgClr("rgb(204 204 204)");
            setNoBgClr("rgb(204 204 204)");
            setAnimation(true);
            setValue(null);
            if (response.data.data != null) {
                if (response.data.data.next) {
                    //display next question
                    setQuestionNo(response.data.data.questionNo || questionNo + 1);
                    setQuestion(response.data.data.question);
                    setItemId(response.data.data.itemId);
                    setL1(response.data.data.l1);
                    setL2(response.data.data.l2);
                } else {
                    // The ids ride in the address so the result screen survives a reload.
                    const query = new URLSearchParams();
                    const finishedPackage = sessionStorage.getItem('packageId');
                    const finishedAssessment = sessionStorage.getItem('assessmentId');
                    if (finishedPackage) query.set('package', finishedPackage);
                    if (finishedAssessment) query.set('assessment', finishedAssessment);
                    const qs = query.toString();
                    const resultUrl = '/assessments/' + seoName + '/results' + (qs ? '?' + qs : '');
                    window.location.replace(resultUrl);
                }
            }
        }
    };


    return (
        <>
                    <div className="app-main flex-column flex-row-fluid " id="kt_app_main">
                        <div className="d-flex flex-column flex-column-fluid">
                            <div id="kt_app_content" className="app-content  flex-column-fluid " >
                            {alertMsg ?
                <SweetAlert
        title=""
        timeout={10000}
        showConfirm={false}
        style={{ width: "200px", height: "100px" }}
      > <img src={loading} width="50px" height="50px"/>
      </SweetAlert>
      :<></>}

                                <div id="kt_app_content_container" className="app-container  container-xxl ">
                                    <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                                        <div className="col">

                                            <div className="card card-flush h-md-100">
                                                <div className="card-body pt-7">
                                                    <div className="card-title align-items-start flex-column text-center">
                                                        <h3 className="card-label fw-bold text-gray-800 fs-35">Assessment : {seoName}</h3>
                                                    </div>
                                                </div>
                                                <form method="post" className="show-section p-40">

                                                    <section className="steps">
                                                        <div className="step-inner">

                                                            {questionNo && maxQuestions ?
                                                                <div className="quiz-progress mb-6" aria-live="polite">
                                                                    <div className="text-gray-600 fs-6 mb-2">Question {questionNo} of up to {maxQuestions}</div>
                                                                    <div className="progress h-6px" role="progressbar" aria-valuemin={0}
                                                                        aria-valuemax={maxQuestions} aria-valuenow={questionNo}>
                                                                        <div className="progress-bar bg-primary"
                                                                            style={{ width: Math.min(100, Math.round(100 * questionNo / maxQuestions)) + '%' }}></div>
                                                                    </div>
                                                                </div>
                                                            : <></>}
                                                            <div className="quiz-question">
                                                                {questionNo}. {question}
                                                            </div>

                                                            <fieldset id="step1">
                                                                <div className="input-field">
                                                                    <div className="option" style={{ backgroundColor: yesBgClr }}>
                                                                        A
                                                                    </div>
                                                                    <div className={animation ? "radio-field bounce-left" : null}>
                                                                        <input type="radio" id={`q${questionNo}-yes`} name={`q${questionNo}`} value="yes"
                                                                        checked={value === "yes"}
                                                                        onChange={(e) => onChangeValue(e.target.value)} style={{ backgroundColor: yesBgClr }} />
                                                                        <label htmlFor={`q${questionNo}-yes`}>{trueOp}</label>
                                                                    </div>
                                                                </div>
                                                                <div className="input-field">
                                                                    <div className="option" style={{ backgroundColor: noBgClr }}>
                                                                        B
                                                                    </div>
                                                                    <div className={animation ? "radio-field bounce-left delay-100" : null}>
                                                                        <input type="radio" id={`q${questionNo}-no`} name={`q${questionNo}`} value="no"
                                                                        checked={value === "no"}
                                                                        onChange={(e) => onChangeValue(e.target.value)} style={{ backgroundColor: noBgClr }} />
                                                                        <label htmlFor={`q${questionNo}-no`}>{falseOp}</label>
                                                                    </div>
                                                                </div>
                                                            </fieldset>
                                                            <img className="thinking_bro" src={bgImage} alt="thinking-bro" />
                                                        </div>

                                                    </section>

                                                </form>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
        </>
    );
}

export default Quiz;